import React, { useEffect, useState } from 'react';
import { Form, Input } from 'antd';
import { IUserAddressRulesField } from 'base/interfaces/address'
import { getFormItemRules } from '@base/account/address/utils'

type IProps = {
    itemRules: IUserAddressRulesField
}

const FormInput: React.FC<IProps> = (props) => {
    const { itemRules } = props;
    const {
        key,
        labelTitle,
        placeholder,
        maxlength,
    } = itemRules;

    return (
        <Form.Item
            label={labelTitle}
            name={key}
            rules={getFormItemRules(itemRules)}
        >
            <Input
                // autoComplete="no-fill" // off 无效
                placeholder={placeholder}
                autoComplete={'no-fill'}
                {...(+maxlength > 0 ? {
                        maxLength: +maxlength
                    } : {}
                )}
            />
        </Form.Item>
    );
};

export default FormInput